import { canAccess } from "../providers/commons/canAccess";
export type NavItem = { to: string; label: string; key: string };
export function workspaceNavigation(role: string): NavItem[] {
  const items = [{ to: "/", label: "Главная", key: "home" }];
  if (canAccess(role, { resource: "tasks", action: "list" }))
    items.push({ to: "/tasks", label: "Календарь", key: "tasks" });
  if (canAccess(role, { resource: "counterparties", action: "list" }))
    items.push({
      to: canAccess(role, { resource: "contacts", action: "list" })
        ? "/contacts"
        : "/companies",
      label: "Контрагенты",
      key: "counterparties",
    });
  if (canAccess(role, { resource: "deals", action: "list" }))
    items.push({ to: "/deals", label: "Управление", key: "management" });
  else if (canAccess(role, { resource: "work_projects", action: "list" }))
    items.push({ to: "/work-projects", label: "Мои проекты", key: "projects" });
  items.push({ to: "/workspace", label: "Кабинет", key: "workspace" });
  return items;
}
export function routeGroup(path: string) {
  if (/^\/(contacts|companies)(\/|$)/.test(path)) return "counterparties";
  if (/^\/(deals|analytics)(\/|$)/.test(path)) return "management";
  if (path.startsWith("/work-projects")) return "projects";
  if (path.startsWith("/tasks") || path.startsWith("/my-tasks")) return "tasks";
  if (path === "/") return "home";
  return "workspace";
}
export function routeResource(path: string) {
  const segment = path.split("/")[1];
  if (segment === "admin-tools") return "admin_tools";
  if (segment === "tasks") return "tasks";
  if (segment === "my-tasks") return "tasks";
  if (segment === "work-projects") return "work_projects";
  if (segment === "settings" || segment === "configuration")
    return "configuration";
  if (segment === "import") return "import";
  if (
    ["contacts", "companies", "sales", "deals", "analytics"].includes(segment)
  )
    return segment;
  return null;
}
